import { t } from '@/utils/i18n'
import React from 'react'
import { utils, constant } from '@/utils'
import { Image } from 'antd-mobile'
import styles from './index.module.less'
const {
  product: { IMAGE_DEFAULT },
} = constant

interface IProps {
  thumb: any
  extClass?: string
  hasVideo?: boolean
  width?: number
  height?: number
  isInvalid?: boolean // 是否是失效
  onGoto?: () => void
}

const { px2rem } = utils
const IMG_SIZE = 200

const Thumb: React.FC<IProps> = ({
  thumb,
  extClass,
  hasVideo,
  isInvalid = false,
  width = IMG_SIZE,
  height = IMG_SIZE,
  onGoto,
}) => {
  const imgWidth = px2rem(width)
  const imgHeight = px2rem(height)
  const previewBoxClass = `preview-box ${extClass ? extClass : ''}`
  const previewBoxClassStyle = previewBoxClass
    .split(' ')
    .map((className) => `${className ? styles[className] : ''}`)
    .join(' ')

  return (
    <div
      className={previewBoxClassStyle}
      onClick={() => {
        onGoto && onGoto()
      }}
    >
      <Image
        fit="cover"
        className={styles['preview-img']}
        src={thumb.url || thumb.backupUrl || IMAGE_DEFAULT}
        width={imgWidth}
        height={imgHeight}
      />

      {hasVideo && <div className={styles['thumb-video']}></div>}

      {
        isInvalid && <span className={ styles['thumb-mask'] }>{t('补货中')}</span>
      }
    </div>
  )
}

export default Thumb
